import React, { useState } from 'react';
import { useNewSizeGuideContext } from './context/useNewSizeGuideContext';

import styles from './CategoriesSelector.module.scss';
import { CarretArrowDown } from '../../atoms/icons';
import clsx from 'clsx';
import randomID from '../../../utils/randomID';

export const CategoriesSelector = () => {
  const { categories, activeGuide, setActiveGuide, setActiveDefaultTab } = useNewSizeGuideContext();
  const [showDropdown, setShowDropdown] = useState(false);

  const toggleDropdown = () => setShowDropdown(!showDropdown);

  return (
    <div className={clsx(styles.container, { [styles.showList]: showDropdown })}>
      <div
        className={styles.header}
        onClick={toggleDropdown}
      >
        {activeGuide?.label}
        <CarretArrowDown className={styles.arrowIcon} />
      </div>
      <div className={styles.list}>
        <ul>
          {categories.map((cat, key) => {
            return cat.sub.map((subCat) => (
              <li
                key={randomID(`subCat_${cat.name}_${key}`)}
                onClick={() => {
                  setActiveDefaultTab();
                  setActiveGuide(subCat);
                  toggleDropdown();
                }}
              >
                {`${cat.name} ${subCat.name}`}
              </li>
            ))
          })}
        </ul>
      </div>
    </div>
  )
};

